<template>
  <div id="whysignup" class="d-flex justify-content-center">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-7 col-md-6 col-sm-12 col-xs-12">
          <img class="img-fluid" src="../assets/people.jpg" alt />
        </div>

        <div class="col-lg-5 col-md-6 col-sm-11 col-xs-12 p-4">
          <div class="row">
            <h2>Why Signup ?</h2>
            <div class="col-12 p-2">
              <p>
                Every African SME is entitled to a free
                TribeID.
              </p>
              <p>
                If you or someone you know runs a startup or
                an SME, it makes a lot of sense to get a
                TribeID for it. Whilst the focus is on
                enterprises (“social” or traditional
                commercial) that offer goods and services,
                there is no rule against NGOs and other
                entities applying for one; in fact, it is
                encouraged.
              </p>
              <p>
                With a TribeID profile, an enterprise is
                immediately plugged into a growing
                infrastructure for doing business across
                Africa that a growing number of Pan-African
                Institutions are devoting resources to
                extend, enrich, entrench and maintain.
              </p>
              <p>
                Having a TribeID means belonging to a
                growing movement of African changemakers
                committed to using entrepreneurship,
                commerce, trade, and innovation to unite and
                integrate Africa, and by so doing to unlock
                tremendous amounts of latent prosperity that
                will reshape the fortunes of this beautiful
                continent.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>